import { render, staticRenderFns } from "./propertyIndex.vue?vue&type=template&id=b36b0850&scoped=true&"
import script from "./propertyIndex.vue?vue&type=script&lang=js&"
export * from "./propertyIndex.vue?vue&type=script&lang=js&"
import style0 from "./propertyIndex.vue?vue&type=style&index=0&id=b36b0850&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36b0850",
  null
  
)

export default component.exports